<template>
  <div style="padding: 0 10px">
    <ScanQuery @onQuery="queryCall" ph="输入分拣框">
      <el-button
        :disabled="!pkgCode"
        slot="customize"
        type="primary"
        @click="finish"
      >
        打印
      </el-button>
    </ScanQuery>
    <div style="text-align: left;margin-bottom: 10px;">
      分拣框中组合组数：<span style="font-size: 30px;color:red">{{ totalNum }}</span>
      <span style="margin-left: 30px;">体积：</span>
      <el-radio-group v-model="volume" :disabled="hasVolume">
          <div style="text-align: left">
            <el-radio-button label="XS">超小</el-radio-button>
            <el-radio-button label="S">小</el-radio-button>
            <el-radio-button label="M">中</el-radio-button>
            <el-radio-button label="L">大</el-radio-button>
            <el-radio-button label="XL">超大</el-radio-button>
          </div>
        </el-radio-group>
    </div>
    <el-card style="margin-bottom: 10px">
      <WmsTable
        :hasHeader="false"
        :columns="columns"
        :dataSource="dataSource"
        :scrollY="300"
        :isPagination="false"
      >
        <template #productImg="{ text, record }">
          <ImgPreviews :images="[text]"></ImgPreviews>
        </template>
      </WmsTable>
    </el-card>
    <div style="display: flex; justify-content: space-between; width: 100%">
      <el-card style="flex-grow: 1">
        <div slot="header" style="text-align: left">
          <span>附加项</span>
        </div>
        <el-table
          :data="additionList"
          height="300px"
          border
          style="width: 100%"
        >
          <el-table-column label="附加项名称" prop="additionName">
            <template slot-scope="scope">
              {{ scope.row.additionName || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="辅料名称" prop="ingredientsName">
            <template slot-scope="scope">
              {{ scope.row.ingredientsName || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="辅料图片" prop="ingredientsImg">
            <template slot-scope="scope">
              <ImgPreviews
                :images="[scope.row.ingredientsImg]"
                :width="100"
                :height="100"
                v-if="scope.row.ingredientsImg"
              />
              <span v-if="!scope.row.ingredientsImg">-</span>
            </template>
          </el-table-column>
          <el-table-column label="辅料库位" prop="gridCode">
            <template slot-scope="scope">
              {{ scope.row.gridCode || "-" }}
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-card
        style="margin-left: 10px; flex-shrink: 0; width: 50%"
        v-if="basketVOList && basketVOList.length"
      >
        <div slot="header" style="text-align: left">
          <span>同组合商品分拣框</span>
        </div>
        <div style="width: 100%" class="boxBlock">
          <div
            v-for="i in basketVOList"
            :key="i.basketCode"
            class="boxItem"
            :style="`background-color: ${
              i.useStatus == 0 ? '#d9d9d9' : '#048060'
            };`"
          >
          {{ i.basketCode }}
          </div>
          <!-- <div class="boxItem" style="background-color: #048060;">篮子编号:LZ0003</div>
          <div class="boxItem" style="background-color: #048060;">篮子编号:LZ0004</div>
          <div class="boxItem" style="background-color: #048060;">篮子编号:LZ0005</div>
          <div class="boxItem" style="background-color: #048060;">篮子编号:LZ0006</div>
          <div class="boxItem" style="background-color: #d9d9d9;">篮子编号:LZ0007</div> -->
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import ScanQuery from "@/components/ScanQuery";
import WmsTable from "@/components/WmsTable";
import ImgPreviews from "@/components/ImgPreviews";
import { columns } from "./data";
import { getBasketInfo, doBasketPackFinish } from "@/apis/combination";
import { getIngredientsBatch } from "@/apis/checking";
import { pkgDetail } from "@/apis/outStock";

export default {
  name: "combination",
  components: { ScanQuery, WmsTable, ImgPreviews },
  data() {
    return {
      columns,
      query: {
        code: "",
      },
      totalNum: 0,
      dataSource: [],
      additionList: [],
      basketVOList: [],
      showBoxBlock: true,
      pkgCode: "",
      basketCode: "",
      packCode: "",
      volume: '',
      hasVolume: false
    };
  },
  computed: {},
  methods: {
    queryCall: function (payload) {
      if (payload.code) {
        this.getDetail(payload.code);
      }
    },
    getDetail(basketCode) {
      getBasketInfo({ basketCode: basketCode }).then(({ code, data }) => {
        if (code == 0) {
          this.dataSource = data.packItemVOList;
          this.totalNum = data.totalNums;
          this.basketVOList = data.basketVOList;
          this.basketCode = basketCode;
          this.packCode = data.packCode;
          this.pkgCode = data.pkgCode;
          this.volume = data.volume || ''
          data.volume && ( this.hasVolume = true )
          let ingredientsSku = [];
          data.additionalList.forEach((item, index) => {
            if (item.ingredientsSku) {
              ingredientsSku.push(item.ingredientsSku);
            }
          });
          if(ingredientsSku.length){
            getIngredientsBatch(ingredientsSku).then((res) => {
              for (let i in data.additionalList) {
                data.additionalList[i].ingredientsSku && res.data
                  ? (data.additionalList[i].gridCode = res.data.filter(
                      (v) =>
                        v.ingredientsSku ==
                        data.additionalList[i].ingredientsSku
                    )[0].gridCode)
                  : "";
              }
              this.additionList = data.additionalList;
            });
          }else{
            this.additionList = data.additionalList;
          }  
        }
      });
    },
    finish() {
      if(!this.volume){
        this.$message.warning("请选择体积");
        return
      }
      doBasketPackFinish({
        basketCode: this.basketCode,
        packCode: this.packCode,
        volume: this.volume
      }).then(({ code }) => {
        if (code == 0) {
          this.$message.success("成功");
          let Arr = [{ pkgCode: this.pkgCode }];
          this.$wmsPrint.print().templatePrintByPkg(Arr);
          this.resetPage();
          // pkgDetail({pkgCode:this.pkgCode}).then(({code,data})=>{
          //   if(code == 0){
          //     this.$printPkg(1, data.systemSource, Arr).catch(res => {
          //       this.$wmsPrint.print().templatePrintByPkg(Arr);
          //     })
          //   }else{
          //     this.$wmsPrint.print().templatePrintByPkg(Arr);
          //   }
          // })
        }
      });
    },
    resetPage() {
      this.dataSource = [];
      this.additionList = [];
      this.basketVOList = [];
      this.pkgCode = "";
      this.basketCode = "";
      this.packCode = "";
      this.totalNum = 0
    },
  },
  mounted() {}
};
</script>

<style scoped>
.boxBlock {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.boxItem {
  padding: 0 10px;
  height: 60px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 22px;
  margin: 5px 5px 0 0;
}
</style>
